module.exports = __webpack_public_path__ + "static/media/tablet.4f4395ee.png";